





























import { Component, Prop } from 'vue-property-decorator';
import { Venue } from '@/interfaces/models/Venue';
import VFormBuilder from '@/components/shared/form/VFormBuilder.vue';
import { InputType } from '@/enums/InputType';
import { OrderFlavor } from '@/enums/OrderFlovor';
import StackedForm from '@/mixins/StackedForm';
import { mixins } from 'vue-class-component';
import CustomerGroup from '@/mixins/CustomerGroup';
import { VenueLabel } from '@/interfaces/models/VenueLabel';

@Component({
  components: { VFormBuilder },
})
export default class ExportForm extends mixins(StackedForm, CustomerGroup) {
  @Prop({ type: Boolean, required: false }) public disableFlavor!: boolean;
  @Prop({ type: Boolean, required: false }) public disableDates!: boolean;
  @Prop({ type: Array, required: false }) public venues!: Venue[];
  @Prop({ type: String, default: '' }) public title!: string;
  @Prop({ type: Boolean, default: false }) public loading!: boolean;
  @Prop({ type: Boolean, default: false }) public disableVenues!: boolean;
  @Prop({ type: Boolean, default: true }) public disableCustomerGroup!: boolean;

  @Prop({ type: Boolean, default: true }) disableLabel!: boolean;
  @Prop({ type: Array, default: () => [] }) labels!: VenueLabel[];

  public $refs!: {
    venueForm: InstanceType<typeof VFormBuilder> & { form: { venue: string } };
    labelForm: InstanceType<typeof VFormBuilder> & { form: { labels: string[] } };
    customerGroupForm: InstanceType<typeof VFormBuilder> & { form: { customerGroup: string } };
    flavorForm: InstanceType<typeof VFormBuilder> & { form: { flavor: OrderFlavor } };
    dateForm: InstanceType<typeof VFormBuilder> & { form: { range: { from: string; to: string } } };
  };

  get selection() {
    return {
      venue: this.$refs.venueForm && this.$refs.venueForm.form ? this.$refs.venueForm.form.venue : null,
      flavor: this.$refs.flavorForm && this.$refs.flavorForm.form ? this.$refs.flavorForm.form.flavor : null,
      ...this.$refs.dateForm.form.range,
    };
  }

  public getData() {
    return {
      venue: this.$refs.venueForm && this.$refs.venueForm.form ? this.$refs.venueForm.form.venue : null,
      flavor: this.$refs.flavorForm && this.$refs.flavorForm.form ? this.$refs.flavorForm.form.flavor : null,
      labels: this.$refs.labelForm && this.$refs.labelForm.form ? this.$refs.labelForm.form.labels : null,
      customerGroup:
        this.$refs.customerGroupForm && this.$refs.customerGroupForm.form
          ? this.$refs.customerGroupForm.form.customerGroup
          : null,
      ...this.$refs.dateForm.form.range,
    };
  }

  get customerGroupItems() {
    return [
      {
        name: 'customerGroup',
        type: InputType.Select,
        label: 'billing.form.customerGroup',
        items: this.scopedCustomerGroups,
      },
    ];
  }

  get labelItems() {
    return [
      {
        name: 'label',
        type: InputType.Autocomplete,
        label: 'billing.form.label',
        multiple: true,
        items: this.labels,
        itemValue: '_id',
        itemText: 'name',
      },
    ];
  }

  get venueItems() {
    return [
      {
        name: 'venue',
        type: InputType.Autocomplete,
        label: 'billing.form.venue',
        items: this.venues,
        itemValue: '_id',
        itemText: 'name',
        rules: !this.disableCustomerGroup || !this.disableLabel ? '' : 'required',
      },
    ];
  }

  get dateItems() {
    return [
      {
        name: 'range',
        type: InputType.DateRange,
        label: 'billing.form.range',
        rules: 'required',
      },
    ];
  }

  get flavors(): string[] {
    return Object.values(OrderFlavor);
  }

  get flavorItems() {
    return [
      {
        name: 'flavor',
        type: InputType.Select,
        label: 'billing.form.flavor',
        items: this.flavors,
      },
    ];
  }

  public doExport() {
    if (!this.$refs.flavorForm && !this.$refs.dateForm && !this.$refs.venueForm) {
      this.$emit('export');
      return;
    }
    this.validate().then((res: boolean[]) => {
      if (this.isValid(res)) {
        this.$emit('export', this.getData());
      }
    });
  }
}
